import { createStore } from 'vuex';

export default createStore({
  state() {
    return {
      centersData: [],
      centersLoading: false,
      centersError: null,
      membersData: [],
      membersLoading: false,
      membersError: null
    };
  },
  mutations: {
    setCentersData(state, data) {
      state.centersData = data;
    },
    setCentersLoading(state, val) {
      state.centersLoading = val;
    },
    setCentersError(state, msg) {
      state.centersError = msg;
    },
    setMembersData(state, data) {
      state.membersData = data;
    },
    setMembersLoading(state, val) {
      state.membersLoading = val;
    },
    setMembersError(state, msg) {
      state.membersError = msg;
    }
  },
  actions: {
    async fetchMembersData({ commit }) {
      commit('setMembersLoading', true);
      commit('setMembersError', null);
      try {
        const response = await fetch('https://member.pori.or.id/api/v1/members');
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const json = await response.json();
        commit('setMembersData', json.data || []);
      } catch (error) {
        console.error('Error fetching members data:', error);
        commit('setMembersError', error.message);
      } finally {
        commit('setMembersLoading', false);
      }
    },
    async fetchRadiotherapyCenters({ commit }) {
      commit('setCentersLoading', true);
      commit('setCentersError', null);
      try {
        const response = await fetch('https://member.pori.or.id/api/v1/radiotherapy-centers');
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const json = await response.json();
        const centers = (json.data || []).map((center) => ({
          ...center,
          Provinsi: center.provinsi?.name || '',
          position: [center.latitude, center.longitude],
          link: center.maps_url,
          radiasi_eksterna: center.layanan?.radiasi_eksterna || false,
          brakhiterapi: center.layanan?.brakhiterapi || false,
          bpjs: center.layanan?.bpjs || false,
          swasta: center.layanan?.swasta || false,
          waiting_externa: center.waktu_tunggu?.radiasi_eksterna ?? null,
          waiting_brachyteraphy: center.waktu_tunggu?.brakhiterapi ?? null
        }));
        commit('setCentersData', centers);
      } catch (error) {
        console.error('Error fetching radiotherapy centers data:', error);
        commit('setCentersError', error.message);
      } finally {
        commit('setCentersLoading', false);
      }
    }
  }
});
